import React, { useState, memo } from "react";
import _ from "lodash";
import Modal from "react-modal";
import { ListGroup, Button, ModalHeader, ListGroupItem } from "components/Shared";
//@ts-ignore
import { saveAs } from "file-saver";
import axios from "v2/utils/axios";

interface Props {
	forms: any[];
}

// Modal-driven multi-select Download for Forms — mirrors components/Documents/Download.
// Posts the selected form ids to v2/forms/download-zip, which returns a presigned
// URL pointing at a freshly built .zip on S3; we fetch + saveAs to trigger the
// browser download.
const FormsDownload = ({ forms }: Props) => {
	const [isModalOpen, setModalOpen] = useState(false);
	const [ids, setIds] = useState<string[]>([]);
	const [busy, setBusy] = useState(false);

	const downloadSelected = () => {
		if (!ids.length) return;
		setBusy(true);
		axios
			.post(`${process.env.REACT_APP_API_ENDPOINT_V2}forms/download-zip`, { keys: ids })
			.then((res: any) => {
				const path = res.data.path;
				const filename = res.data.filename;
				return fetch(path)
					.then((r) => r.blob())
					.then((blob) => saveAs(blob, filename));
			})
			.catch(() => {
				/* swallow — user can retry from the modal */
			})
			.finally(() => {
				setBusy(false);
				setModalOpen(false);
			});
	};

	return (
		<div className="documents-download">
			<Button small kind="download" onClick={() => setModalOpen(true)} />
			<Modal
				isOpen={isModalOpen}
				onRequestClose={() => setModalOpen(false)}
				contentLabel="zip"
				className="zip-download-document-modal"
			>
				<ModalHeader title="download" onRequestClose={() => setModalOpen(false)} />
				<section className="documents documents-list-view">
					<div className="btn-group">
						<button
							className="btn"
							onClick={(e) => {
								e.preventDefault();
								setIds(_.map(forms, "id"));
							}}
						>
							{" "}
							Select All{" "}
						</button>
						<button
							className="btn"
							onClick={(e) => {
								e.preventDefault();
								setIds([]);
							}}
						>
							{" "}
							Select None{" "}
						</button>
					</div>
					<ListGroup
						resource="form"
						className="document-items download-documents"
						collection={forms}
						renderRow={(form: any) => (
							<ListGroupItem
								icon={<i className="far fa-file-word" style={{ fontSize: 20 }} />}
								heading={form.name || form.code}
								selected={_.includes(ids, form.id)}
								onSelect={() => setIds(_.concat(ids, form.id))}
								onUnselect={() => setIds(_.filter(ids, (id) => id !== form.id))}
							/>
						)}
					/>
				</section>
				<footer>
					<Button disabled={!ids.length || busy} onClick={downloadSelected} kind="download" />
				</footer>
			</Modal>
		</div>
	);
};

export default memo(FormsDownload);
